module.exports = __webpack_public_path__ + "img/costEffective.c53df78d.jpg";